export default __webpack_public_path__ + "static/media/step2.c01a296a.svg";